const MAX = 1e30;

export function isValidValue(value: number): boolean {
  return !isNaN(value) && ((value >= 0 && value < MAX) || (value < 0 && value > -MAX));
}

export function isValidYValue(value: number): boolean {
  return 0 <= value && value <= 1;
}
